import { render, staticRenderFns } from "./PrinterItemSimpleCard.vue?vue&type=template&id=03468b4d&scoped=true"
import script from "./PrinterItemSimpleCard.vue?vue&type=script&lang=js"
export * from "./PrinterItemSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./PrinterItemSimpleCard.vue?vue&type=style&index=0&id=03468b4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03468b4d",
  null
  
)

export default component.exports